import { axiosInstance } from "../../Utils/AxiosInstance";

export const GetAllCategoryApi = async () => {
  try {
    const response = await axiosInstance.get(`/Store/Category/GetAll`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddCategoryApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/Store/Category/Create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteCategoryApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`/Store/Category/Delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const EditCategoryApi = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/Store/Category/Edit/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
